import superMeta from '../_AR_CAT/metaArCatNode.mjs'

export default {
    ...superMeta,
    name: '算法步骤',
    type: 'ALG_SUMMARY',
}
